export const STORE_CATEGORIES = [
  { value: "restaurant", label: "Restaurant" },
  { value: "cafe", label: "Café" },
  { value: "bar", label: "Bar" },
  { value: "nightclub", label: "Nightclub" },
  { value: "retail", label: "Retail" },
  { value: "beauty", label: "Beauty & Personal Care" },
  { value: "fitness", label: "Fitness" },
  { value: "entertainment", label: "Entertainment" },
  { value: "other", label: "Other" },
] as const;

export const STORE_STATUSES = ["active", "suspended", "hidden"] as const;
export type StoreStatus = (typeof STORE_STATUSES)[number];

export const REPORT_STATUSES = ["pending", "reviewed", "resolved", "dismissed"] as const;
export type ReportStatus = (typeof REPORT_STATUSES)[number];

export const REPORT_TARGET_TYPES = ["store", "discount", "reward", "event"] as const;
export type ReportTargetType = (typeof REPORT_TARGET_TYPES)[number];

/** Max price in dollars when price limit bypass is active */
export const BYPASS_MAX_PRICE_DOLLARS = 30_000;

/** Default pagination page size */
export const PAGE_SIZE = 20;
